import { Link } from 'react-router-dom'
import './index.css'

export const Header = () => {
    return(
        <nav>
            <div className='header-wrapper'>
                <div className='header-content'>
                    Avatarmash
                </div>
            </div>
        </nav>
    )
}